import {
  makeStyles,
  Theme,
  createStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import { useParams } from "react-router-dom";
import { InstalledAppDetailTemplate } from "./InstalledAppDetailTemplate";
import { InstalledAppListTemplate } from "./InstalledAppListTemplate";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3, 2),
      marginBottom: 50,
    },
    footer: {
      marginTop: 20,
    },
  })
);

/**
 * 連携アプリに関するページコンポーネントです。
 */
export const InstalledAppManagerPage: React.FC = () => {
  const classes = useStyles();
  const { id: appIdFromParam } = useParams<{ id?: string }>();

  return (
    <>
      <Paper className={classes.root}>
        <Typography variant="h5" component="h3">
          連携アプリ
        </Typography>

        <Typography>
          連携しているアプリケーションの詳細表示・連携解除が行えます。
        </Typography>

        <br />

        {appIdFromParam ? (
          <InstalledAppDetailTemplate />
        ) : (
          <InstalledAppListTemplate />
        )}
      </Paper>
    </>
  );
};
